module.exports = __webpack_public_path__ + "static/img/8.bc38a0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/8.png
// module id = mr5Y
// module chunks = 0